/* eslint-disable no-else-return */
/* eslint-disable react/function-component-definition */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-param-reassign */
/* eslint-disable no-console */
/* eslint-disable security/detect-object-injection */
/* eslint-disable import/no-unresolved */
import { FC, memo, Dispatch, SetStateAction, useEffect } from "react";
import { MedicalQuestionnaireAPIData } from "src/helpers/FormDetails/ProposalDetails/interfaces";
import { FormikProps } from "formik";
import { getConditionValue } from "src/helpers/FormDetails/ProposalDetails/resources";
import CustomizedSwitches from "../CustomToggleButton";
import MedicalTextBox from "../MedicalLifeStyle/MedicalTextBox";
import CustomSelect from "../CustomSelect";
import CustomRadioButton from "../CustomRadioButton";
import CustomCheckBox from "../CustomCheckBox";

interface Props {
  question: MedicalQuestionnaireAPIData.QuestionnaireReducerKeys;
  formik: FormikProps<any>;
  setErrorBoundary: Dispatch<SetStateAction<boolean>>;
  editable?: boolean;
  setErrorJSON: Dispatch<SetStateAction<Record<string, any>>>;
  errorJSON: Record<string, any>;
}

const getDynamicFields = (
  formik: FormikProps<any>,
  subQ: MedicalQuestionnaireAPIData.Question,
  editable: boolean,
  errorJSON: Record<string, any>,
  index?: number
) => {
  console.log("sub questions", subQ);
  switch (subQ?.type) {
    case "input": {
      return (
        <div
          key={index}
          className="xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-0 lg:mr-0 md:mr-0 sm:mr-10 mr-4 "
        >
          {subQ?.label && (
            <p className="mb-4 text-daintree font-montserrat text-sm font-medium">{subQ?.label}</p>
          )}
          <div className="flex">
            <MedicalTextBox
              requiredStar={subQ?.validation?.required}
              label={subQ?.placeholder || subQ?.label}
              onChange={formik?.handleChange}
              handleBlur={formik?.handleBlur}
              value={formik?.values?.[subQ?.key]}
              name={subQ?.key}
              error={(formik?.errors?.[subQ?.key] || "") as string}
              touched={formik?.touched?.[subQ?.key] as boolean}
              disabledField={!editable}
            />
            {subQ?.helperText && (
              <span className="ml-2">
                <p className="mt-8 xl:whitespace-nowrap lg:whitespace-nowrap md:whitespace-normal sm:whitespace-nowrap text-xs">
                  {subQ?.helperText}
                </p>
              </span>
            )}
          </div>
        </div>
      );
    }

    case "dropdown": {
      return (
        <div
          key={index}
          className="xl:ml-0 lg:ml-0 md:ml-0 sm:ml-10 ml-4 xl:mr-0 lg:mr-0 md:mr-0 sm:mr-10 mr-4 xl:mt-0 lg:mt-0 md:mt-0 sm:mt-6 mt-6"
        >
          <p className="mb-4 text-daintree font-montserrat text-sm font-medium whitespace-nowrap">
            {subQ?.label}
          </p>
          <CustomSelect
            requiredStar={subQ?.validation?.required}
            label={subQ?.placeholder || subQ?.label}
            options={(subQ?.options || []) as string[]}
            onChange={formik?.handleChange}
            setFieldTouched={formik?.setFieldTouched}
            value={formik?.values?.[subQ?.key]}
            name={subQ?.key}
            error={(formik?.errors?.[subQ?.key] || "") as string}
            touched={formik?.touched?.[subQ?.key] as boolean}
            disabledField={!editable}
          />
        </div>
      );
    }

    case "radio": {
      return (
        <div
          key={index}
          className="xl:ml-0 lg:ml-0 md:ml-0 sm:ml-10 ml-4 xl:mr-0 lg:mr-0 md:mr-0 sm:mr-10 mr-4 xl:mt-0 lg:mt-0 md:mt-0 sm:mt-6 mt-6"
        >
          <CustomRadioButton
            requiredStar={subQ?.validation?.required}
            name={subQ?.key}
            label={subQ?.label}
            options={(subQ?.options || []) as string[]}
            setFieldValue={formik?.setFieldValue}
            setFieldTouched={formik?.setFieldTouched}
            error={(formik?.errors?.[subQ?.key] || "") as string}
            touched={formik?.touched?.[subQ?.key] as boolean}
            defaultValue={formik?.values?.[subQ?.key] || ""}
            disabled={!editable}
          />
        </div>
      );
    }

    case "checkbox": {
      return (
        <div
          key={index}
          className="flex xl:ml-10 lg:ml-10 xl:mr-13.25 lg:mr-10 items-center flex-col xl:flex-row lg:flex-row order-first"
        >
          <div className="flex flex-col space-y-1">
            <p className="flex xl:whitespace-nowrap lg:whitespace-nowrap ">{subQ?.label}</p>
            {errorJSON?.[subQ?.label] && (
              <div className="whitespace-nowrap text-hotShot text-xxs">
                <p>Atleast one value is required</p>
              </div>
            )}
          </div>
          <div className="flex flex-wrap gap-6">
            {subQ?.options?.map((option: any, subQIndex: number) => (
              <div key={subQIndex} className="flex lg:ml-9.75 xl:ml-11.75">
                <div className="space-y-2">
                  <div>
                    <CustomCheckBox
                      label={option?.label}
                      name={option?.key}
                      handleBlur={formik?.handleBlur}
                      setFieldValue={formik?.setFieldValue}
                      isReview={!editable}
                      checked={formik?.values?.[option?.key]}
                    />
                  </div>
                  {option?.leadingQuestions?.map(
                    (leadingQuestion: any, leadingQuestionIndex: number) =>
                      getConditionValue(leadingQuestion?.showIf as Record<string, any>, formik) && (
                        <>
                          <MedicalTextBox
                            className="w-32"
                            key={leadingQuestionIndex}
                            smokerTextBox
                            label={leadingQuestion?.placeholder || leadingQuestion?.label}
                            onChange={formik?.handleChange}
                            handleBlur={formik?.handleBlur}
                            value={formik?.values?.[leadingQuestion?.key]}
                            name={leadingQuestion?.key}
                            error={formik?.errors?.[leadingQuestion?.key] as string}
                            touched={formik?.touched?.[leadingQuestion?.key] as boolean}
                            disabledField={!editable}
                          />
                          {leadingQuestion?.helperText && (
                            <span className="ml-2">
                              <p className="mt-8 xl:whitespace-nowrap lg:whitespace-nowrap md:whitespace-normal sm:whitespace-nowrap text-xs">
                                {leadingQuestion?.helperText}
                              </p>
                            </span>
                          )}
                        </>
                      )
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      );
    }

    default:
      return null;
  }
};

const getConditionalFields = (
  formik: FormikProps<any>,
  description: MedicalQuestionnaireAPIData.QuestionnaireConfig,
  editable: boolean,
  errorJSON: Record<string, any>
) => (
  <div className="flex flex-wrap gap-4 mt-3">
    {getConditionValue(
      description?.subQuestions?.showIf!,
      formik,
      description?.subQuestions?.logical
    ) &&
      description?.subQuestions?.questions?.map((subQ, index: number) => {
        if (
          (subQ?.showIf &&
            getConditionValue(subQ?.showIf as Record<string, any>, formik, subQ?.logical)) ||
          !subQ?.showIf
        )
          return getDynamicFields(formik, subQ, editable, errorJSON, index);
        else return null;
      })}
  </div>
);

const QuestionnireFields: FC<Props> = ({
  question,
  formik,
  setErrorBoundary,
  editable = true,
  setErrorJSON,
  errorJSON
}) => {
  const prepareComponent = () => {
    try {
      const { description, questionnaireID } = question;
      const setErrorState = () => {
        let errorMessage = {};
        let result = false;
        const isConditionTrue = getConditionValue(description?.subQuestions?.showIf!, formik);
        description?.subQuestions?.questions?.forEach((subQ) => {
          if (subQ?.type === "checkbox" && isConditionTrue) {
            result = !!subQ?.options
              ?.map((option: any) => formik?.values?.[option?.key])
              ?.some(Boolean);
            if (!result) {
              errorMessage = {
                ...errorMessage,
                [subQ?.label]: subQ?.validation?.message || "This is required field"
              };
            } else {
              errorMessage = {
                ...errorMessage,
                [subQ?.label]: null
              };
            }
          } else {
            errorMessage = {
              ...errorMessage,
              [subQ?.label]: null
            };
          }
        });
        // if (Object.keys(errorMessage)?.length) {
        setErrorJSON((prev) => ({ ...prev, ...errorMessage }));
        // } else setErrorJSON({});
      };

      useEffect(() => {
        setErrorState();
      }, [formik?.values]);

      switch (description?.type) {
        case "switch": {
          return description?.condition &&
            !getConditionValue(description?.condition!, formik, description?.logical) ? null : (
            <div>
              <div className="flex xl:mt-7 lg:mt-7 md:mt-7 sm:mt-10.75 mt-10.75 ">
                <p className="xl:w-219.25 lg:w-auto md:w-auto sm:w-auto w-67.25 flex text-justify lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-39 lg:mr-39 md:mr-39 sm:mr-39 mr-4">
                  {description?.heading}
                </p>
                <div className="xl:mr-10 lg:mr-10 md:mr-10 sm:mr-10 mr-4">
                  <CustomizedSwitches
                    isEnabled={editable}
                    toggleState={formik?.values?.[questionnaireID]}
                    fieldName={questionnaireID}
                    setFieldValue={formik?.setFieldValue}
                  />
                </div>
              </div>
              {getConditionalFields(formik, description, editable, errorJSON)}
            </div>
          );
        }
        case "text": {
          return description?.condition &&
            !getConditionValue(description?.condition!, formik, description?.logical) ? null : (
            <div>
              <div className="flex items-center my-6">
                <p className="xl:w-202.5 xl:h-5 flex text-justify xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-0 lg:mr-0 md:mr-0 sm:mr-0 mr-17.25 ">
                  {description?.heading}
                </p>
              </div>
              {description?.subQuestions?.questions?.map((subQ: any, index: number) => (
                <>
                  {subQ?.type === "switch" && (
                    <div className="flex items-center mb-6">
                      <p className="xl:w-202.5 lg:w-202.5 md:w-202.5 sm:w-202.5 w-68.25 flex text-justify xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-55 lg:mr-55 md:mr-55 sm:mr-55 mr-3">
                        {index + 1}. {subQ?.heading}
                      </p>

                      <div className="xl:mr-10 lg:mr-10 md:mr-10 sm:mr-10 mr-3.75">
                        <CustomizedSwitches
                          isEnabled={editable}
                          toggleState={formik?.values?.[subQ?.key]}
                          fieldName={subQ?.key}
                          setFieldValue={formik?.setFieldValue}
                        />
                      </div>
                    </div>
                  )}
                  {subQ?.subQuestions
                    ? getConditionalFields(formik, subQ, editable, errorJSON)
                    : getDynamicFields(formik, subQ, editable, errorJSON)}
                </>
              ))}
            </div>
          );
        }
        default:
          return null;
      }
    } catch (e) {
      setErrorBoundary(true);
      console.error(e);
      return null;
    }
  };

  useEffect(() => {
    formik?.setFieldValue("height.centimeter.cm", "");
    formik?.setFieldValue("height.inchFeet.inches", "");
    formik?.setFieldValue("height.inchFeet.feet", "");
  }, [formik?.values?.measurement]);

  const element = prepareComponent();
  return (
    <div>
      {element}
      {element && (
        <hr className="border-dashed border-t-2 border-daintree mt-6 mb-6  opacity-10 xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-10 lg:mr-10 md:mr-10 sm:mr-10 mr-4" />
      )}
    </div>
  );
};

QuestionnireFields.defaultProps = {
  editable: false
};

export default memo(QuestionnireFields);
